<template>
  <div>
    <template v-for="(saldo, index) in saldos">
      <px-entrega-produtos-compras-item-content-saldo-row
        :key="`row-${saldo.id}`"
        :saldo="saldo"
        :compra-produto="compraProduto"/>
      <v-divider :key="`div-${saldo.id}`" v-if="index !== saldos.length - 1"/>
    </template>
  </div>
</template>

<script>

import EntregaProdutosComprasItemContentSaldoRow
from './EntregaProdutosComprasItemContentSaldoRow.vue';

export default {
  props: {
    compraProduto: Object,
    saldos: {
      type: Array,
      required: true,
    },
  },
  components: {
    pxEntregaProdutosComprasItemContentSaldoRow:
    EntregaProdutosComprasItemContentSaldoRow,
  },
};
</script>
